<ng-container *ngIf="!headerConfig?.flatHeaderConfig?.isFlatHeader">
  <div id="Header_Container_Header"
    class="container">
    <div class="row">
      <div class="navbar-header">
        <button type="button"
          (click)="toggleMobileMenu()"
          class="navbar-toggle collapsed"
          data-toggle="collapse"
          data-target="#navBar"
          aria-expanded="false"
          [attr.data-dl]="JSON.stringify({da_track: 'true'})"
          hukid="toggleNavigationButton">
          <span class="sr-only">Toggle navigation</span>
          <i class="icon icon-menu"
            aria-hidden="true"></i>
        </button>
        <a class="navbar-brand"
          [class.default-cursor]="headerConfig.disableLogoLink"
          (click)="navigateLogoLink()"
          role="button"
          [attr.data-dl]="JSON.stringify({da_track: 'true'})"
          hukid="logoLinkButton">
          <img alt="The Hartford"
            src="https://s0.hfdstatic.com/sites/higux/dist/images/logo.svg">
        </a>
      </div>
    </div>
  </div>
  <header class="navbar navbar-default collapse navbar-collapse"
    id="Header_Header_NavBar"
    [ngClass]="{'in':showMobileMenuOptions}">
    <div class="navbar-primary"
      id="Header_Container_PrimaryNav"
      *ngIf="headerConfig">
      <div class="container">
        <div class="">
          <ul class="nav navbar-nav navbar-left"
            *ngIf="headerConfig.primaryNavLeft">
            <button id="Header_Button_ToggleNavigation"
              type="button"
              (click)="toggleMobileMenu()"
              class="navbar-toggle-close collapsed"
              data-toggle="collapse"
              data-target="#navBar"
              aria-expanded="false"
              [attr.data-dl]="JSON.stringify({da_track: 'true'})">
              <span class="sr-only">Toggle navigation</span>
              <i class="icon icon-close"></i>
            </button>
            <li class="dropdown"
              *ngFor="let menu of headerConfig.primaryNavLeft">
              <a [ngClass]="{'hide-dropdown-toggle': !menu.subHeaderDetails}"
                class="dropdown-toggle fs-4 fw-normal ps-0"
                data-toggle="dropdown"
                role="button"
                aria-haspopup="true"
                aria-expanded="false"
                [attr.data-dl]="JSON.stringify({da_track: 'true'})">
                <ng-container
                  [ngTemplateOutlet]="(menu.label !== '' && !onLandingPage) ? accountTitle : treoTitle"></ng-container>
                <ng-template #accountTitle>
                  <span class="header-title"
                    [textContent]="menu.label"></span>
                </ng-template>
                <ng-template #treoTitle>
                  <span class="header-title">{{treoMainTitle}}
                    <span>{{treoSubTitle}}</span><sup>SM</sup></span>
                </ng-template>
                <i class="icon icon-double-caret"
                  aria-hidden="true"></i>
              </a>
              <ng-container *ngIf="this.loaderService.getItem('userId')">
                <ul class="dropdown-menu"
                  *ngIf="menu.subHeaderDetails">
                  <ng-container *ngFor="let subMenu of menu.subHeaderDetails">
                    <ng-container *ngIf="subMenu.role ==='separator'; else submenu">
                      <li role="separator"
                        class="divider"></li>
                    </ng-container>
                    <ng-template #submenu>
                      <li>
                        <a [id]="subMenu.id ? subMenu.id : null"
                          [attr.data-dl]="JSON.stringify({da_track: 'true'})"
                          hukid="subMenuClick">{{subMenu.label}}</a>
                      </li>
                    </ng-template>
                  </ng-container>
                </ul>
              </ng-container>
            </li>
          </ul>
          <ng-container *ngIf="this.loaderService.getItem('userId')">
            <ul class="nav navbar-nav navbar-icons navbar-right pull-right"
              *ngIf="headerConfig.primaryNavRight">
              <ng-container *ngFor="let menu of headerConfig.primaryNavRight">
                <ng-container *ngIf="menu.subHeaderDetails; else rightMenuLink">
                  <li class="dropdown hidden-sm hidden-xs">
                    <a class="dropdown-toggle"
                      data-toggle="dropdown"
                      role="button"
                      aria-haspopup="true"
                      aria-expanded="false"
                      [attr.data-dl]="JSON.stringify({da_track: 'true'})">

                      {{ menu.label }}
                      <ng-container *ngIf="menu.label === 'Alerts' && showAlertIcon">
                        <span class="exclamation-badge">
                          &#33;
                        </span>
                      </ng-container>
                      <i [ngClass]="{'hidden': !menu.icon}"
                        class="icon {{ menu.icon }}">
                        <span class="sr-only">{{ menu.label }}</span>
                      </i>
                    </a>
                    <ul class="dropdown-menu"
                      *ngIf="menu.subHeaderDetails">
                      <li *ngFor="let subMenu of menu.subHeaderDetails">
                        <a *ngIf="!subMenu.isNonNgUrl"
                          (click)="navigateUrl(subMenu)"
                          [id]="subMenu.id ? subMenu.id : null"
                          [attr.data-dl]="JSON.stringify({da_track: 'true'})"
                          role="button">
                          {{ subMenu.label }}
                          <ng-container *ngIf="subMenu.label === 'Notifications' && notificationCount > 0">
                            <span class="notification-badge">
                              {{ notificationCount }}
                            </span>
                          </ng-container>
                        </a>
                        <a *ngIf="subMenu.isNonNgUrl"
                          (click)="navigateUrl(subMenu)"
                          [id]="subMenu.id ? subMenu.id : null"
                          href="{{ subMenu.link }}"
                          [attr.data-dl]="JSON.stringify({da_track: 'true'})"
                          role="button">
                          {{ subMenu.label }}
                          <ng-container *ngIf="subMenu.label === 'Notifications' && notificationCount > 0">
                            <span class="notification-badge">
                              {{ notificationCount }}
                            </span>
                          </ng-container>
                        </a>
                      </li>
                    </ul>


                  </li>
                </ng-container>
                <ng-template #rightMenuLink>
                  <li>
                    <a [id]="menu.id ? menu.id : null"
                      (click)="navigateUrl(menu)"
                      [attr.data-dl]="JSON.stringify({da_track: 'true'})">
                      <i [ngClass]="{'hidden':!menu.icon}"
                        class="icon {{menu.icon}}">
                        <span class="badge"
                          *ngIf="menu.badge">{{menu.badge}}</span>
                      </i>
                      <span>{{menu.label}}</span>
                    </a>
                  </li>
                </ng-template>
              </ng-container>
            </ul>
          </ng-container>
        </div>
      </div>
    </div>
    <div class="navbar-secondary"
      id="Header_Container_SecondaryNav">
      <div class="container">
        <div class="row">
          <ng-container *ngIf="headerConfig.secondryNav  || headerConfig.primaryNavRight">
            <ul class="nav navbar-nav"
              [ngClass]="{'d-none': onLandingPage}">
              <ng-container *ngFor="let menu of headerConfig.secondryNav">
                <li class="dropdown"
                  [ngClass]="{'dropdown-active': isActive(menu.link), 'open': isMobileDropDownOpen(menu.link)}"
                  (click)="toggleMobileDropDown(menu.link)">
                  <a [id]="menu.id ? menu.id : null"
                    [ngClass]="{'no-icon': !menu.subHeaderDetails?.length}"
                    class="dropdown-toggle disabled"
                    data-toggle="dropdown"
                    role="button"
                    aria-haspopup="true"
                    aria-expanded="false"
                    [attr.data-dl]="JSON.stringify({da_track: 'true'})"
                    (click)="navigateUrl(menu)">
                    <span [textContent]="menu.label"></span>
                  </a>
                  <div class="dropdown-menu"
                    *ngIf="menu.subHeaderDetails?.length || menu.subHeaderDetailsRight?.length">
                    <div class="mega-menu">
                      <div class="col-md-6 mega-menu-left"
                        *ngIf="menu.subHeaderDetails?.length || menu.label==='Dashboards'">
                        <ul>
                          <li class="fw-bold">{{menu.label}}</li>
                          <li *ngFor="let submenu of menu.subHeaderDetails">
                            <ng-container
                              *ngIf="submenu.label !== 'Location Code Change Log'; then pageLink; else excelLink"></ng-container>
                            <ng-template #pageLink>
                              <a id="submenu-management-item-{{i}}"
                                [attr.data-dl]="JSON.stringify({da_track: 'true'})"
                                (click)="navigateUrl(submenu)">{{submenu.label}}</a>
                            </ng-template>
                            <ng-template #excelLink>
                              <a role="button"
                                (click)="downloadLocationExcel()"
                                [attr.data-dl]="JSON.stringify({da_track: 'true'})"
                                id="submenu-management-item-{{i}}">{{submenu.label}}</a>
                            </ng-template>
                          </li>
                        </ul>
                      </div>
                      <div class="col-md-6 mega-menu-left right-panel">
                        <div *ngIf="menu.label === 'CLAIMS' || menu.label === 'Claims'">
                          <app-claim-menu></app-claim-menu>
                        </div>
                        <div *ngIf="menu.label === 'DASHBOARDS' || menu.label === 'Dashboards'">
                          <ul>
                            <li *ngFor="let submenu of menu.subHeaderDetailsRight; let last = last">
                              <a [id]="submenu.id ? submenu.id : null"
                                (click)="navigateUrl(submenu)"
                                [attr.data-dl]="JSON.stringify({da_track: 'true'})">{{submenu.label}} </a>
                              <div class="sub-menu-desc"
                                [ngClass]="{'last-item':last}">
                                {{submenu.description}}</div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
              </ng-container>
              <ng-container *ngFor="let menu of headerConfig?.primaryNavRight">
                <li class="visible-xs visible-sm">
                  <a [id]="menu.id ? menu.id : null"
                    (click)="navigateUrl(menu)"
                    [attr.data-dl]="JSON.stringify({da_track: 'true'})">
                    <i [ngClass]="{'hidden':!menu.icon}"
                      class="icon {{menu.icon}}"></i>
                    <span>{{menu.label}}</span>
                  </a>
                </li>
                <li class="visible-xs visible-sm"
                  *ngFor="let subMenu of menu.subHeaderDetails">
                  <a [id]="subMenu.id ? subMenu.id : null"
                    (click)="navigateUrl(subMenu)"
                    [attr.data-dl]="JSON.stringify({da_track: 'true'})">
                    <i [ngClass]="{'hidden':!subMenu.icon}"
                      class="icon {{subMenu.icon}}"></i>
                    <span>{{subMenu.label}}</span>
                  </a>
                </li>
              </ng-container>
            </ul>
          </ng-container>
          <div class="mobile-logout">
            <a id="Header_HyperLink_Logout"
              (click)="logout()"
              [attr.data-dl]="JSON.stringify({da_track: 'true'})">
              <button class="btn btn-secondary-paired btn-block"
                [attr.data-dl]="JSON.stringify({da_track: 'true'})"
                hukid="logoutButton">Logout</button>
            </a>
          </div>
        </div>
      </div>
    </div>
  </header>
</ng-container>